import React from "react";
import { Link } from "react-scroll";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { motion } from "framer-motion";

import { data } from "../../data";

const LeftBanner = () => {
  let positions = data?.banner?.position
  const [text] = useTypewriter({
    words: positions,
    loop: true,
    typeSpeed: 30,
    deleteSpeed: 15,
    delaySpeed: 2000,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 1, 0.5, 1] },
    },
  };

  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative z-20">
      {/* Ambient glow background */}
      <div className="pointer-events-none absolute -top-16 -left-8 h-56 w-56 rounded-full bg-[radial-gradient(circle_at_center,#ff014f33,transparent_65%)] blur-2xl" />
      <div className="pointer-events-none absolute -bottom-8 -right-8 h-44 w-44 rounded-full bg-[radial-gradient(circle_at_center,#6366f133,transparent_65%)] blur-2xl" />

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="relative max-w-xl w-full flex flex-col gap-4 xl:gap-10 text-center lgl:text-left"
      >
        <motion.div variants={itemVariants} className="inline-block">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/5 bg-white/5 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.25em] text-gray-300 backdrop-blur-md shadow-[0_4px_24px_rgba(255,1,79,0.1)]">
            <span className="h-2 w-2 rounded-full bg-gradient-to-r from-[#ff014f] to-purple-500 animate-pulse" />
            Welcome to my world
          </div>
        </motion.div>

        <div className="flex flex-col gap-5">
          <motion.h1 variants={itemVariants} className="text-4xl sm:text-5xl lgl:text-6xl xl:text-7xl font-bold text-white tracking-tight leading-[1.1]">
            Hi, I&apos;m{" "}
            <span className="bg-gradient-to-br from-[#ff014f] via-pink-400 to-purple-500 bg-clip-text text-transparent capitalize drop-shadow-lg">
              {data?.banner?.name}
            </span>
          </motion.h1>

          <motion.h2 variants={itemVariants} className="text-xl sm:text-2xl lgl:text-3xl font-medium text-gray-300 flex items-center gap-2 h-[40px] sm:h-[48px]">
            <span>a</span>
            <span className="text-white font-semibold tracking-wide drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]">{text}</span>
            <Cursor
              cursorBlinking="false"
              cursorStyle="|"
              cursorColor="#ff014f"
            />
          </motion.h2>
        </div>

        <motion.div variants={itemVariants} className="flex flex-wrap items-center justify-center lgl:justify-start gap-4 pt-2">
          <Link
            to="projects"
            smooth={true}
            offset={-70}
            duration={500}
            className="group relative inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#ff014f] via-pink-500 to-purple-600 px-7 py-3 text-sm font-semibold text-white shadow-[0_10px_30px_rgba(255,1,79,0.3)] transition-all duration-300 hover:scale-105 hover:shadow-[0_15px_40px_rgba(255,1,79,0.5)] overflow-hidden cursor-pointer"
          >
            <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" />
            <span className="relative z-10">View Projects</span>
          </Link>

          <Link
            to="technologies"
            smooth={true}
            offset={-70}
            duration={500}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/5 px-7 py-3 text-sm font-medium text-gray-200 backdrop-blur-md transition-all duration-300 hover:bg-white/10 hover:border-white/20 hover:scale-105 hover:text-white cursor-pointer"
          >
            View Skills
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default LeftBanner;
